module.exports = "<div>\n  <span fxFlex style=\"text-align: center\">\n    <mat-input-container>\n      <input matInput type=\"number\" [(ngModel)]=\"amount\" placeholder=\"Amount\">\n    </mat-input-container>\n    <button mat-raised-button color=\"accent\" (click)=\"overrideBid()\">Override</button>\n  </span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/bid/bid-override.html
// module id = ./src/app/components/bid/bid-override.html
// module chunks = main